var exports = {
  "zr": "x93eb46d8--3aef45--root",
  "x6": "x93eb46d8--3aef45--button",
  "Pf": "x93eb46d8--3aef45--label",
  "Kk": "x93eb46d8--3aef45--icon",
  "MK": "x93eb46d8--3aef45--menu",
  "qJ": "x93eb46d8--3aef45--menu-item",
  "cB": "x93eb46d8--3aef45--menu-item-icon",
  "xZ": "x93eb46d8--3aef45--menu-item-active",
};

module.exports = exports;
